import { InjectionToken } from '@angular/core';
import { Firestore, getFirestore } from 'firebase/firestore';

export const FIRESTORE_TOKEN = new InjectionToken<Firestore>('Firebase Firestore', {
  providedIn: 'root',
  factory: () => getFirestore()
});
